export default "__VITE_ASSET__CmqCF4iS__ 400w, __VITE_ASSET__p$fLI6Zo__ 800w, __VITE_ASSET__DtGJKYFw__ 1024w";